module.exports = __webpack_public_path__ + "img/image 64 (Traced).6ea5a5f2.png";